export default "__VITE_ASSET__DF6qELn5__"